import { Box, Card, CardContent, CardHeader, Divider, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader } from "../../components/CustomLoader";
import { emailServices } from "../../services/AllServices";
import errorHandler from "../../utils/errorHandler";
import { capitalize } from "../../utils/helpers";
import CardLayout from "../../layouts/CardLayout";

const ViewEmailDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchEmailData = async () => {
    try {
      setLoading(true);
      const response = await emailServices.getByIdEmail({ id });
      setData(response.data.data);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchEmailData();
    }
  }, [id]);

  if (loading) {
    return (
      <CardLayout title="Email Template Details">
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px" }}>
          <Loader />
        </Box>
      </CardLayout>
    );
  }

  if (!data) {
    return (
      <CardLayout title="Email Template Details">
        <Typography>No data found</Typography>
      </CardLayout>
    );
  }

  return (
        <CardLayout>
        <Card>
        <CardHeader title="Email Template Details" />
        <CardContent>
          <Box mb={2}>
            <Typography variant="subtitle2" color="text.secondary">
              Title
            </Typography>
            <Typography variant="h6">{capitalize(data?.name)}</Typography>
          </Box>

          <Divider />

          <Box my={2}>
            <Typography variant="subtitle2" color="text.secondary">
              Subject
            </Typography>
            <Typography variant="h6">{capitalize(data?.subject)}</Typography>
          </Box>

          <Divider />

          <Box my={2}>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
              Body Message
            </Typography>
              <Typography
                component="div"
                dangerouslySetInnerHTML={{ __html: data?.content || "" }}
              />
          </Box>
        </CardContent>
      </Card>
    </CardLayout>
  );
};

export default ViewEmailDetail;
  